"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
exports.PostalPLRule = function () {
  $.validator.addMethod("postalPL", function (value, element) {
    var reg = /^[0-9]{2}-[0-9]{3}$/;
    return this.optional(element) || reg.test(value);
  }, $.validator.format("Kod pocztowy jest niepoprawny."));
}();